import LocalStorageService from 'services/LocalStorageService';

import GeneralTracker from '../GeneralTracker';


export default class RouteTracker extends GeneralTracker {
  CAPTURE_NAME = 'session:routes';
  DATALAYER = true;
  VERSION = '1';

  constructor() {
    super();

    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    this.interval = null;
    LocalStorageService.set('routeMatched', null);
  }

  setHandlers() {
    const service = this.getService();
    service.on('routeMatched', this.onRouteMatch);
  }

  onRouteMatch = (payload) => {
    const { match, location } = payload;
    const path = location.pathname;
    const lastPath = LocalStorageService.get('routeMatched');

    if (lastPath === path) {
      return;
    }

    if (match.isExact && path === match.url) {
      LocalStorageService.set('routeMatched', path);
      this.track({ CurrentRoute: match });
    }
  };
}
